var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.119,
    height: 70.945,
    viewBox: "0 0 80.119 70.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_548",
    "data-name": "Grupo 548",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_547",
    "data-name": "Grupo 547"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    cx: 5.504,
    cy: 5.504,
    r: 5.504,
    transform: "translate(24.693 17.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_879",
    "data-name": "Trazado 879",
    d: "M75.38,67.271A16.951,16.951,0,0,0,65.9,62.76V34.779a11.006,11.006,0,0,0-3.134-7.645A10.682,10.682,0,0,0,55.12,24H10.779a11.006,11.006,0,0,0-7.645,3.134A10.682,10.682,0,0,0,0,34.779V80.42a11.006,11.006,0,0,0,3.134,7.645A10.682,10.682,0,0,0,10.779,91.2H53.668A16.174,16.174,0,0,0,75.38,67.271ZM4.052,34.779A6.4,6.4,0,0,1,6.04,30.116a6.708,6.708,0,0,1,4.74-1.988H55.12a6.787,6.787,0,0,1,6.728,6.728V58.708L50.533,47.394a2.053,2.053,0,0,0-2.905,0L30.58,64.518,19.036,52.9a2.053,2.053,0,0,0-2.905,0L4.052,65.13ZM10.7,87.3v-.153a6.708,6.708,0,0,1-4.74-1.988,6.977,6.977,0,0,1-1.911-4.74V70.94L17.583,57.332,29.127,68.876a2.126,2.126,0,0,0,2.905,0L49.081,51.751,60.242,62.989l-.688.229a7.1,7.1,0,0,0-.994.306c-.306.076-.612.229-.917.306a2.289,2.289,0,0,0-.612.306,7.1,7.1,0,0,0-.764.382l-1.147.688c-.229.153-.382.229-.612.382-.153.076-.229.153-.382.229a9.224,9.224,0,0,0-1.835,1.605,16.173,16.173,0,0,0-4.74,11.467,16.807,16.807,0,0,0,.382,3.364c.076.306.153.535.229.841.229.765.459,1.529.765,2.293v.076a14.023,14.023,0,0,0,.994,1.835Zm61.695,0a12.094,12.094,0,0,1-16.9.153c-.306-.306-.612-.688-.917-.994-.229-.229-.459-.535-.688-.765a7.26,7.26,0,0,1-.764-1.3c-.153-.306-.306-.535-.459-.841a6.457,6.457,0,0,1-.382-1.3c-.076-.306-.229-.688-.306-.994a12.653,12.653,0,0,1-.229-2.446,12.271,12.271,0,0,1,3.517-8.562,11.82,11.82,0,0,1,8.562-3.517A12.271,12.271,0,0,1,72.4,70.252a11.949,11.949,0,0,1,3.517,8.562A12.227,12.227,0,0,1,72.4,87.3Z",
    transform: "translate(0 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_880",
    "data-name": "Trazado 880",
    d: "M306.818,265.012a2.665,2.665,0,0,0-.688-.459,2.231,2.231,0,0,0-.688-.153h-.153a2.231,2.231,0,0,0-.688.153,1.8,1.8,0,0,0-.688.459l-4.74,4.74a2.054,2.054,0,1,0,2.905,2.905l1.223-1.223v8.409a2.064,2.064,0,0,0,4.128,0v-8.409l1.223,1.223a2.054,2.054,0,0,0,2.905-2.905Z",
    transform: "translate(-241.53 -218.454)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.4e2160c7.svg";
export { ForwardRef as ReactComponent };